export default __webpack_public_path__ + "static/media/tandoori-chicken.ea87308b.mp4";